import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * TINA Textarea — multi-line input primitive. Mirrors <Input>'s border,
 * focus ring, and disabled styling so forms stay visually consistent.
 */
export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "flex w-full rounded-md border border-slate-300 bg-surface px-3 py-2 text-base",
          "placeholder:text-slate-400",
          "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/15",
          "disabled:cursor-not-allowed disabled:bg-surface-alt disabled:opacity-60",
          className
        )}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
